import { render, staticRenderFns } from "./catchPriceSetting.vue?vue&type=template&id=47b96f3e&scoped=true&"
import script from "./catchPriceSetting.vue?vue&type=script&lang=js&"
export * from "./catchPriceSetting.vue?vue&type=script&lang=js&"
import style0 from "./catchPriceSetting.vue?vue&type=style&index=0&id=47b96f3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b96f3e",
  null
  
)

export default component.exports